// ContainerNumberValidator.js
// Centralized container number validation logic for ISO 6346

const letterMap = {
  A: 10, B: 12, C: 13, D: 14, E: 15, F: 16, G: 17, H: 18, I: 19, J: 20,
  K: 21, L: 23, M: 24, N: 25, O: 26, P: 27, Q: 28, R: 29, S: 30, T: 31,
  U: 32, V: 34, W: 35, X: 36, Y: 37, Z: 38
};

export function validateContainerNumber(number) {
  if (!number || !/^[A-Z]{4}[0-9]{7}$/.test(number)) return false;
  let numericArr = [];
  for (let i = 0; i < 4; i++) {
    const val = letterMap[number[i]];
    if (!val) return false;
    numericArr.push(val);
  }
  for (let i = 4; i < 10; i++) {
    numericArr.push(parseInt(number[i], 10));
  }
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += numericArr[i] * Math.pow(2, i);
  }
  let checkDigit = sum % 11;
  if (checkDigit === 10) checkDigit = 0;
  return checkDigit === parseInt(number[10], 10);
}

export function calculateCheckDigit(number) {
  if (!number || !/^[A-Z]{4}[0-9]{6}$/.test(number)) return '';
  let numericArr = [];
  for (let i = 0; i < 4; i++) {
    const val = letterMap[number[i]];
    if (!val) return '';
    numericArr.push(val);
  }
  for (let i = 4; i < 10; i++) {
    numericArr.push(parseInt(number[i], 10));
  }
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += numericArr[i] * Math.pow(2, i);
  }
  let checkDigit = sum % 11;
  if (checkDigit === 10) checkDigit = 0;
  return checkDigit.toString();
}
